import React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import EditPositionForm, { IPositionEdit } from "./EditPositionForm/EditPositionForm";
import WorkIcon from "@material-ui/icons/Work";
import { IManagementStore } from "@src/Stores/Management/types";
import { Values } from "@src/Tools/Values";
import { Person, PositionAssignment } from "@src/Interfaces/Entity/Person";
import { IStringDict } from "@src/Stores/Values/types";
import _ from "lodash";
import { STWrapperModal, STModal } from "./styles";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  person: Person;
  management?: IManagementStore;
}

@inject("management")
@observer
export default class PersonPositionEdit extends React.Component<IProps> {
  @observable editOpened: boolean = false;

  handleOpenEdit = () => {
    this.editOpened = true;
  };

  handleCloseEdit = () => {
    this.editOpened = false;
  };

  handleSubmit = async (values: IPositionEdit) => {
    let locationWithPositions = _(values.positions)
      .keys()
      .filter(p => values.positions[p] && values.positions[p].length > 0)
      .value();
    await this.props.management.savePerson({
      ...this.props.person,
      positionAssignments: _(locationWithPositions).map(x => {
        var assignment: PositionAssignment = {
          locationId: x,
          positionId: values.positions[x]
        };
        return assignment;
      }).value()
    });
    this.editOpened = false;
  };

  getPositions = (): IStringDict[] => {
    var positionAssignments = _.cloneDeep(this.props.person.positionAssignments);
    var actualPositions = _(this.props.management.activeLocations)
      .map(location => {
        var positionWithinLocation = _.find(positionAssignments, x => x.locationId == location.id);
        var existingPosition = !_.isNil(positionWithinLocation) &&
          _.some(this.props.management.activePositions, p => p.id == positionWithinLocation.positionId) &&
          _.includes(location.locationPositions.map(lp => lp.positionId), positionWithinLocation.positionId);
        if (existingPosition) {
          return positionWithinLocation;
        }
        return {
          locationId: location.id,
          positionId: ''
        };
      }).value();
    var positions: IStringDict[] = [];
    _.each(actualPositions, x => {
      positions[x.locationId] = x.positionId;
    });
    return positions;
  }

  render() {
    return (
      <>
        <RoundButton
            icon={<WorkIcon/>}
            tooltipTitle={Values.getLocalizationValue("editPositions")}
            onClick={() => this.handleOpenEdit()}
        />
        
        <STModal
          open={this.editOpened}
          onClose={this.handleCloseEdit}
        >
          <STWrapperModal width={500}>
            <EditPositionForm
              onClose={this.handleCloseEdit}
              onSubmit={this.handleSubmit}
              positions={this.getPositions()}
            />
          </STWrapperModal>
        </STModal>
      </>
    );
  }
}
